export default __webpack_public_path__ + "static/media/Logo.df797854.png";